import * as Yup from 'yup';
import { Activity } from '../../../common/models';

export function useValidationSchema() {
  return Yup.object<Activity>().shape({
    name: Yup.string().nullable().required(),
  });
}
